export const tabRoutes = ['home', 'shipping-integration', 'semen-pull'];

export const tabNames = ['Home', 'Shipping Integration', 'Semen Pull'];

export const storageLocationTypes = [
  { label: 'Embryos', value: 100000000 },
  { label: 'Semen', value: 100000001 },
  { label: 'Both', value: 100000002 },
  { label: 'Lab Tank (TOG Use)', value: 100000003 },
];

export const semenTransactionTypeOptions = [
  { label: 'Missing', value: 'Missing' },
  { label: 'Fertilization', value: 'Fertilization' },
  { label: 'Adjustment', value: 'Adjustment' },
  { label: 'Breeding', value: 'Breeding' },
  { label: 'Receipt', value: 'Receipt' },
  { label: 'Shipment', value: 'Shipment' },
  { label: 'Transfer', value: 'Transfer' },
];
